import { render, staticRenderFns } from "./SingleFileUpload.vue?vue&type=template&id=58fef8e6&scoped=true"
import script from "./SingleFileUpload.vue?vue&type=script&lang=js"
export * from "./SingleFileUpload.vue?vue&type=script&lang=js"
import style0 from "./SingleFileUpload.vue?vue&type=style&index=0&id=58fef8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fef8e6",
  null
  
)

export default component.exports